export const configUrl = {
  baseUrl: process.env.REACT_APP_BASE_URL,
  baseUrlForCoffeeQuotesCoffeeWeb: process.env.REACT_APP_BASE_URL_FOR_COFFEEQUOTES_COFFEEWEB,
  coffeeQuotesIceMarketHttpUrl: process.env.REACT_APP_BASE_URL_ICEMARKET_HTTP,
  forexHttpUrl: process.env.REACT_APP_BASE_URL_FOREX_API,
  razorpaySDKUrl: 'https://checkout.razorpay.com/v1/checkout.js',
  coffeeWebAiUrl: process.env.REACT_APP_BASE_URL_COFFEE_WEB_AI,
  coffeeQuizBaseUrl: process.env.REACT_APP_BASE_URL_COFFEE_QUIZ,
  coffeeCastBaseUrl: process.env.REACT_APP_BASE_URL_COFFEE_CAST,
  globalDifferentialsBaseUrl: process.env.REACT_APP_BASE_URL_GLOBAL_DIFFERENTIALS,
  coffeePricesBaseUrl: process.env.REACT_APP_BASE_URL_COFFEE_PRICES,
  coffeePostBaseUrl: process.env.REACT_APP_BASE_URL_COFFEE_POST
}
